export const LOGO_URL = '/media/logos/default.svg'
export const LOGO_DARK_URL = '/media/logos/default-dark.svg'
export const LOGO_SMALL_URL = '/media/logos/default-small.svg'
export const PLACEHOLDER_IMAGE_URL = '/media/custom/placeholder.png'
export const AUTH_LS_KEY = 'auth_credentials_mqu'

export const certificateStatus = [
  {
    key: "draft",
    label: "Qoralama"
  },
  {
    key: "active",
    label: "Qabul qilingan",
  },
  {
    key: "inactive",
    label: "Bekor qilingan",
  }
]
